import React, { FunctionComponent } from "react";
import rehypeReact from "rehype-react";
import { Pre } from "../rehypes/Pre";
import { CodeBlock } from "../rehypes/CodeBlock";
import { ArticlePharagraph } from "../rehypes/ArticlePharagraph";
import { H2 } from "../rehypes/H2";
import { Hr } from "../rehypes/Hr";
import { Quote } from "../rehypes/Quote";
import { H3 } from "../rehypes/H3";
import { H4 } from "../rehypes/H4";
import { FootnoteRef } from "../rehypes/FootnoteRef";
import { ListItem } from "../rehypes/ListItem";
import { ExternalLinkButton } from "../rehypes/ExternalLinkButton";

type Property = {
  htmlAst: string;
}

export const AstRenderer: FunctionComponent<Property> = (props) =>{

  return new rehypeReact({
    createElement: React.createElement,
    components: {
      h2: (prop: any) =>(
        <H2>{prop.children}</H2>
      ),
      h3: (prop: any) =>(
        <H3>{prop.children}</H3>
      ),
      h4: (prop: any) =>(
        <H4>{prop.children}</H4>
      ),
      p: ({props, children, parent}) =>(
        <ArticlePharagraph>{children}</ArticlePharagraph>
      ),
      li: (prop: any) =>(
        <ListItem>{prop.children}</ListItem>
      ),
      pre: (prop: any) =>(
        <Pre>{prop.children}</Pre>
      ),
      code: (prop: any) =>(
        <CodeBlock language={prop.className}>{prop.children}</CodeBlock>
      ),
      sup: (prop: any) =>(
        <FootnoteRef id={prop.id}>{prop.children}</FootnoteRef>
      ),
      hr: () =>(
        <Hr />
      ),
      "quote": (prop: any) =>(
        <Quote from={prop.from} label={prop.label}>{prop.children}</Quote>
      ),
      "linkbutton": (prop: any) =>(
        <ExternalLinkButton href={prop.href}>{prop.children}</ExternalLinkButton>
      ),
    }
  }).Compiler(props.htmlAst);
}
